import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setTech({ commit }, id) {
    commit(types.SET_TECH, id)
  },
  setTechData({ commit }, data) {
    commit(types.SET_TECHDATA, data)
  },
  setAddressData({ commit }, data) {
    commit(types.SET_ADDRESS, data)
  },
  setCurrentTechs({ commit }, data) {
    commit(types.SET_TECHS, data)
  },
  setCenter({ commit }, center) {
    commit(types.SET_CENTER, center)
  },
  async getTechAssignments({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getTechAssignments', () =>
      http.get('dispatch/techAssignments', {
        params: searchOptions
      })
    )
    commit(types.SET_TECH_ASSIGNMENTS, r.data)
    return r.data
  },
  async saveAddress({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAddress', () =>
      http.post('dispatch/saveTechAddress', data)
    )
    commit(types.SET_TECH_LOCATION, r.data)
    return r.data
  },
  async saveStatus({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveStatus', () =>
      http.post('dispatch/saveTechStatus', data)
    )
    commit(types.SET_TECH_STATUS, r.data)
    return r.data
  },
  async saveNotes({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveNotes', () =>
      http.post('dispatch/technicianNotes', data)
    )
    return r.data
  },
  async assignTechnician({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'assignTechnician', () =>
      http.post('dispatch/assignTechnician', data)
    )
    return r.data
  },
  async unassignTech({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'unassignTech', () =>
      http.post('dispatch/unassignTechnician', data)
    )
    return r.data
  },
  async getTechSchedule({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getTechSchedule', () =>
      http.get('dispatch/techSchedule', {
        params: searchOptions
      })
    )
    commit(types.SET_TECH_SCHEDULE, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/actions.js